import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formateDateMonth'
})
export class FormateDateMonthPipe implements PipeTransform {

  transform(date, lang: string) {
    var d = new Date(date);

    if(lang == 'fi'){
      var month = d.getMonth() + 1;

      switch(month){
        case 1: {
          return d.getDate() + ' tammi';
        }
        case 2: {
          return d.getDate() + ' helmi';
        }
        case 3: {
          return d.getDate() + ' maalis';
        }
        case 4: {
          return d.getDate() + ' huhti';
        }
        case 5: {
          return d.getDate() + ' touko';
        }
        case 6: {
          return d.getDate() + ' kesä';
        }
        case 7: {
          return d.getDate() + ' heinä';
        }
        case 8: {
          return d.getDate() + ' elo';
        }
        case 9: {
          return d.getDate() + ' syys';
        }
        case 10: {
          return d.getDate() + ' loka';
        }
        case 11: {
          return d.getDate() + ' marras';
        }
        case 12: {
          return d.getDate() + ' joulu';
        }
      }
    }


  }

}
